import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart, updateCartQuantity, clearCart } from '../redux/cartSlice';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Cart = () => {
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);
  console.log("carts",cart);
  const handleRemove = (id) => {
    dispatch(removeFromCart(id));
  };

  const handleQuantityChange = (id, quantity, type, size, color) => {
    if (quantity > 0) {
      if(type == 'increase'){
        let incQuantity = parseInt(quantity) + 1;
        dispatch(updateCartQuantity({ id, quantity:incQuantity,size, color }));
      }
      else if(type == 'decrease'){
        let decQuantity = parseInt(quantity) - 1;
        if(decQuantity > 0){
          dispatch(updateCartQuantity({ id, quantity:decQuantity,size, color }));
        }
      }
      
    }
  };

  const handleClearCart = () => {
    dispatch(clearCart());
  };

  return (
    <div className='container mt-3'>
      <div className='row'>
        <div className='col-6 mb-3'>
          <h2>Shopping Cart</h2>
        </div>
        <div className='col-6 mb-3' style={{display: "flex",alignItems: "anchor-center",justifyContent: "end"}}>
          <button onClick={handleClearCart} className='btn btn-outline-danger'>Clear Cart &nbsp;<span className='fa fa-close'></span></button>
        </div>
      </div>
      
      <div className='row'>
          <table className='table'>
              <thead>
                  <tr>
                    <th>Product</th>
                    <th>Size</th>
                    <th>Color</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
              </thead>
              <tbody>
              {cart.map((item) => (
                <tr key={item.id}>
                  <td>
                    <img src={item.image} style={{width:"100px",height:"100px",objectFit: "contain"}}/>
                    <h4>{item.name}</h4>
                    <i className='fa fa-trash text-danger' style={{cursor:"pointer"}} onClick={() => handleRemove(item.id)}></i>
                  </td>
                  <td>{item.size}</td>
                  <td>{item.color}</td>
                  <td>
                  <div className="quantity-controls w-50">
                      <div class="input-group">
                          <button id="decrement" onClick={() => handleQuantityChange(item.id, item.quantity, 'decrease', item.size, item.color)}>-</button>
                          <input type="number" value={item.quantity} id="input"
                          // onChange={(e) => setQuantity(Number(e.target.value))}
                          min="1" readonly maxLength="10"/>
                          <button id="increment" onClick={() => handleQuantityChange(item.id, item.quantity, 'increase', item.size, item.color)}>+</button>
                      </div>
                  </div>
                  </td>
                  <td style={{textAlign:'right'}}>₹ {item.quantity * item.price}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={4} style={{textAlign:'right', fontWeight: 'bolder'}}>SUB TOTAL</td>
                <td style={{textAlign:'right'}}>₹ {cart.reduce((total, item) => total + item.price * item.quantity, 0)}</td>
              </tr>
              </tbody>
          </table>
      </div>
      {cart.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (<>
        <div className='row'>
          <div className='col-12 mb-3 d-flex justify-content-end'>
            <Link to="/checkout"><button className='btn btn-outline-success'>CHECKOUT</button></Link>
          </div>
        </div>
      </>)}
      <ToastContainer />
    </div>
  );
};

export default Cart;
